import {
  createContext,
  useCallback,
  useContext,
  useState,
  type ReactNode,
} from "react";

type Kind = "success" | "error" | "info";
interface Item {
  id: number;
  kind: Kind;
  msg: string;
}

interface Ctx {
  show(kind: Kind, msg: string): void;
}

const ToastCtx = createContext<Ctx | null>(null);

export function useToast(): Ctx {
  const c = useContext(ToastCtx);
  if (!c) throw new Error("useToast outside ToastProvider");
  return c;
}

let nextId = 1;

export function ToastProvider({ children }: { children: ReactNode }) {
  const [items, setItems] = useState<Item[]>([]);

  const show = useCallback((kind: Kind, msg: string) => {
    const id = nextId++;
    setItems((prev) => [...prev, { id, kind, msg }]);
    setTimeout(() => {
      setItems((prev) => prev.filter((i) => i.id !== id));
    }, 4000);
  }, []);

  return (
    <ToastCtx.Provider value={{ show }}>
      {children}
      <div className="fixed bottom-4 right-4 flex flex-col gap-2 z-50">
        {items.map((i) => (
          <div
            key={i.id}
            className={`px-4 py-2 rounded shadow border text-sm ${
              i.kind === "success"
                ? "bg-gh-surface border-gh-success text-gh-success"
                : i.kind === "error"
                ? "bg-gh-surface border-gh-danger text-gh-danger"
                : "bg-gh-surface border-gh-border text-gh-text"
            }`}
          >
            {i.msg}
          </div>
        ))}
      </div>
    </ToastCtx.Provider>
  );
}
